/**
 * age-gate.js — hỏi "Bạn đã đủ 18 tuổi?" ở lần truy cập đầu tiên (mục 13).
 *
 * Modal để sẵn thuộc tính hidden trong HTML: nếu khách đã xác nhận rồi thì không bao
 * giờ chớp lên trong lúc chờ script. Xác nhận lưu khoá wb_age_ok trong localStorage;
 * trình duyệt chặn localStorage thì hỏi lại mỗi trang — chấp nhận được với cổng tuổi.
 *
 * "Chưa đủ" không đóng modal: đổi lời nhắn và giữ khách lại ở cổng, nhưng vẫn để nút
 * xác nhận phòng khi bấm nhầm. Bấm nền hay Esc cũng KHÔNG đóng — đây là xác nhận bắt buộc.
 *
 * Xác nhận xong bắn sự kiện agegate:confirm trên document — popup khuyến mãi (js/promo-popup.js) chờ
 * sự kiện này mới mở, để khách không bao giờ thấy hai hộp thoại chồng lên nhau.
 *
 * WP: có thể giữ nguyên file này, hoặc thay bằng cookie để PHP không in modal nữa.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var KEY = 'wb_age_ok';
    var modal = document.querySelector('[data-age-gate]');
    if (!modal) return;

    function confirmed() {
        try {
            return window.localStorage.getItem(KEY) === '1';
        } catch (e) {
            return false;
        }
    }

    if (confirmed()) return;

    var confirmBtn = modal.querySelector('[data-age-gate-confirm]');
    var denyBtn = modal.querySelector('[data-age-gate-deny]');
    var text = modal.querySelector('[data-age-gate-text]');
    var lastFocus = document.activeElement;

    modal.hidden = false;
    document.body.classList.add('u-no-scroll');
    // Đợi một khung hình để transition opacity chạy được sau khi bỏ hidden
    window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
        if (confirmBtn) confirmBtn.focus();
    });

    function close() {
        try {
            window.localStorage.setItem(KEY, '1');
        } catch (e) {
            /* không lưu được thì lần sau hỏi lại */
        }
        modal.classList.remove('is-open');
        document.body.classList.remove('u-no-scroll');
        window.setTimeout(function () {
            modal.hidden = true;
        }, 220);
        if (lastFocus && lastFocus.focus) lastFocus.focus();

        var event;
        try {
            event = new CustomEvent('agegate:confirm');
        } catch (e) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent('agegate:confirm', false, false, null);
        }
        document.dispatchEvent(event);
    }

    if (confirmBtn) confirmBtn.addEventListener('click', close);

    if (denyBtn) {
        denyBtn.addEventListener('click', function () {
            if (text) {
                text.textContent = 'Rất tiếc, WINEBOSS chỉ phục vụ khách hàng từ 18 tuổi trở lên. Hẹn gặp lại bạn khi đủ tuổi nhé!';
            }
            denyBtn.hidden = true;
            if (confirmBtn) confirmBtn.textContent = 'Tôi đã bấm nhầm — tôi đủ 18 tuổi';
        });
    }

    // Giữ focus trong modal: chỉ có hai nút nên Tab vòng qua lại giữa chúng
    modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            event.preventDefault();
            return;
        }
        if (event.key !== 'Tab') return;
        var items = [denyBtn, confirmBtn].filter(function (el) {
            return el && !el.hidden;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });
})();
